import { extendTheme } from "@chakra-ui/react";
import { theme as legacyTheme } from "@familyzone/component-library";
import { tooltipTheme } from "./components/tooltip";
import { buttonTheme } from "./components/button";
import fonts from "./fonts";

const overrides = {
	components: {
		Tooltip: tooltipTheme,
		Button: buttonTheme,
	},
	fonts: fonts,
};

// https://v2.chakra-ui.com/docs/styled-system/customize-theme#using-theme-extensions
export const theme = extendTheme(overrides, legacyTheme);
